<template>
  <div id="home">

    <div class="full-header">
      <div class="inner">

        <div class="logo"></div>

        <div class="intro-text">
          <h1>Hi. We’re Label.</h1>
          <h1>We create world class apps &amp; websites.</h1>
        </div>
      </div>

      <a class="down" href="#our-services" @click.prevent="showServices()"></a>
    </div>

    <div class="section our-services" id="our-services">

      <div class="container">
        <div class="row">

          <h1 class="section-heading">our services</h1>

          <div class="col-xs-6 col-sm-3">
            <img class="svg ui" src="~assets/images/home_services_ui.svg" alt="UI / UX Work Services.">
            <h3>UI / UX</h3>
          </div>

          <div class="col-xs-6 col-sm-3">
            <img class="svg web" src="~assets/images/home_services_web.svg" alt="Web Design Services.">
            <h3>Digital Design</h3>
          </div>

          <div class="col-xs-6 col-sm-3">
            <img class="svg dev" src="~assets/images/home_services_dev.svg" alt="Development Services.">
            <h3>Development</h3>
          </div>

          <div class="col-xs-6 col-sm-3">
            <img class="svg integ" src="~assets/images/home_services_integ.svg" alt="Integration Services.">
            <h3>App Development</h3>
          </div>

        </div>
      </div>

    </div>

    <div class="section featured-projects">
      <div class="container">
        <div class="row">

          <div class="col-xs-12">
            <h1 class="section-heading">featured projects</h1>
          </div>

          <div class="col-xs-10 col-xs-offset-1">
            <div class="row">

              <!-- Featured rows of Projects. -->
              <div class="col-xs-12 col-sm-6 col-md-4" v-for="project in features">
                <project-preview :project="project"></project-preview>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Our Clients Section. -->
    <div class="section our-clients">
      <div class="container">
        <div class="row">

          <h1 class="section-heading">some of our clients</h1>

          <img class="clients img-responsive" src="~assets/images/label_portfolio@2x.png" alt="List of our clients.">

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import stash from 'services/Stash';
  import projectPreview from 'components/ProjectPreview';
  import smoothScroll from 'smooth-scroll';

  export default {

    mounted() {
      smoothScroll.init();
    },

    methods: {

      sortProjectsAlpha(a, b) {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        }
        return 0;
      },

      showServices() {
        const anchor = this.$el.querySelector('#our-services');

        smoothScroll.animateScroll(anchor);
      },

    },

    computed: {

      projects() {
        return stash.state.projects.sort(this.sortProjectsAlpha);
      },

      features() {
        return this.projects.filter(p => p.featured);
      },

    },

    components: { projectPreview },

  };
</script>

<style scoped lang="scss">
  .full-header {
    position: relative;
  }

  .down {
    opacity: .7;
    cursor: pointer;
    display: block;
    width: 100%;
    height: 114px;
    background-image: url('~assets/images/scroll_arrow.svg');
    background-repeat: no-repeat;
    background-size: 38px;
    background-position: top center;
    bottom: 0;
    position: absolute;

    &:hover {
      opacity: 1;
    }
  }

  .intro-text h1:last-of-type {
    margin-top: 0;
  }

  .section {
    padding: 75px 0;
  }

  .section-heading {
    margin: 0;
    font-size: 50px;
    color: #638E9C;
    text-align: center;
    margin-bottom: 50px;
    text-transform: uppercase;
  }

  .our-services {
    text-align: center;
    color: #638E9C;
    font-size: 24px;
  }

  .svg {
    &.ui, &.dev, &.web, &.integ {
      width: 75%;
      display: block;
      margin: 0 auto;
    }
  }

  .featured-projects .section-heading {
    margin-bottom: 25px;
  }

  img.clients {
    margin: 0 auto;
    max-width: 75%;
  }

  .our-clients .section-heading {
    margin-bottom: 68px;
  }

  .our-clients {
    padding-bottom: 85px;
  }

  .featured-projects {
    color: #638E9C;
    text-align: center;
    background-color: #F8F8F8;
    padding-bottom: 48px;
  }

  @media (max-width: 767px) {
    .intro-text {
      padding: 0 15px;
    }

    .intro-text h1 {
      font-size: 32px;
    }

    .down {
      height: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?6d4ddb69